// extracted by mini-css-extract-plugin
export default {"root":"_2SB31","toggle":"_2s5XS","count":"_2aNg5","menu":"wxsqf","arrow":"_1dAwY"};